import React from "react";
import { useLocation } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";

const LawyerDetails = () => {
  const location = useLocation();
  const lawyer = location.state;

  if (!lawyer) {
    return <h3 className="text-center mt-3">No Data Found</h3>;
  }

  return (
    <div className="mt-4 container-fluid">
      <div className="text-center">
        <h2 className="fw-bold">{lawyer.name}</h2>
        <p className="text-muted">{lawyer.title}</p>
      </div>
      <Card className="p-4 shadow border-0">

        {/* TOP SECTION */}
        <Row>

          {/* LEFT IMAGE */}
          <Col md={4} className="text-center">
            <Card className="border-0 shadow-sm p-3">
              <img
                src={lawyer.img}
                alt={lawyer.name}
                className="img-fluid rounded"
              />
              <h5 className="mt-3 fw-bold">{lawyer.name}</h5>
              <p className="text-muted">{lawyer.title}</p>
            </Card>
          </Col>

          <Col md={8}>
            <div className="text-start  profile-text">
              {lawyer?.profiles?.slice(0, 2).map((para, index) => (
                <p key={index}>{para}</p>
              ))}
            </div>
          </Col>

        </Row>
        <Row className="mt-3">
          <Col md={12}>
            <div className="text-start">

              {lawyer?.profiles?.slice(2).map((para, index) => {

                const isHeading =
                  para.includes("OTHER ASSIGNMENTS") ||
                  para.includes("MEMBERSHIP OF PROFESSIONAL BODIES") ||
                  para.includes("EDUCATIONAL QUALIFICATIONS") ||
                  para.includes("CONCEPT OF SMART VILLAGE");

                if (isHeading) {
                  return (
                    <h5 key={index} className="mt-4  mb-2 fw-normal">
                      {para} :
                    </h5>
                  );
                }

                return (
                  <p
                    key={index}
                    className="mb-3"
                    style={{ whiteSpace: "pre-line", lineHeight: "1.7" }}
                  >
                    {para}
                  </p>
                );
              })}

            </div>
          </Col>
        </Row>

      </Card>
    </div>
  );
};

export default LawyerDetails;